import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import DivisionCategorySettings, { IDivisionCategorySettingsDispatchProps } from './DivisionCategorySettings'
import {
  updateTeamSettings,
  updateDivisionCategorySettings,
  deleteDivisionCategory,
  renameDivisionCategory,
  getDivisionCategories,
} from '../../store/TeamManagementActions'
import {
  getLastTeamSettingsFail,
  getLastUpdatedTeamSettings,
  getLastUpdatedDivisionCategorySettings,
  getLastDivisionCategorySettingsFail,
  getTeamsList,
} from '../../store/TeamManagementSelectors'
import { CompanyId, DivisionCategoryId } from '../../../../services/api.types'
import { getWhoAmI } from '../../../../common/auth/authActions'
import { managedCompaniesSelector } from '../../../Settings/store/SettingsSelectors'
import { clearNotification } from '../../../../common/notifications/NotificationActions'

interface IDivisionCategorySettingsOwnProps {
  companyId: CompanyId
  selectedGroupId: DivisionCategoryId | null
}

const mapStateToProps = (state: IGlobalState, ownProps: IDivisionCategorySettingsOwnProps) => ({
  companyId: ownProps.companyId,
  selectedGroupId: ownProps.selectedGroupId,
  lastUpdatedTeamSettings: getLastUpdatedTeamSettings(state),
  lastTeamSettingsFail: getLastTeamSettingsFail(state),
  lastUpdatedDivisionCategorySettings: getLastUpdatedDivisionCategorySettings(state),
  lastDivisionCategorySettingsFail: getLastDivisionCategorySettingsFail(state),
  managedCompanies: managedCompaniesSelector(state),
  divisionCategories: state.teamManagement.divisionCategories,
  groupsLoading: state.teamManagement.groupsLoading,
  companyTeams: getTeamsList(state),
})

const mapDispatchToProps: IDivisionCategorySettingsDispatchProps = {
  updateTeamSettings,
  updateDivisionCategorySettings,
  deleteDivisionCategory,
  renameDivisionCategory,
  getWhoAmI,
  clearNotification,
  getDivisionCategories,
}

export default connect(mapStateToProps, mapDispatchToProps)(DivisionCategorySettings)
